import React, { useEffect, useState } from 'react';
import { CarouselProps } from 'react-multi-carousel';
import classNames from 'classnames';
import WidgetCarouselDesktopBasic
    from 'modules/shared/widgets/components/widget-carousel/widget-carousel-deskktop/components/widget-carousel-desktop-basic';
import WidgetBannerSliderProps from 'modules/shared/widgets/components/widget-banner-slider/widget-banner-slider.props';

import './widget-banner-silder-desktop.scss';

const WidgetBannerSliderDesktop: React.FC<WidgetBannerSliderProps> = ({ config, data }) => {
    const [WidgetBannerSliderComponent, setWidgetCarousel] = useState<React.ComponentType<CarouselProps>>(() => WidgetCarouselDesktopBasic);
    const numberOfItems = 1;
    const bigBanner = config.viewType.bigBanners;
    const autoPlay = config.autoPlay;

    useEffect(() => {
        import('react-multi-carousel').then(mod => {
            setWidgetCarousel(() => mod.default);
        });
    }, []);

    const responsive = {
        desktop: {
            breakpoint: { max: 5000, min: 1024 },
            items: numberOfItems
        }
    };

    return (
        <div className={classNames({
            'widget-banner-slider-d': true,
            'widget-banner-slider-d--big': bigBanner
        })}
        >
            <WidgetBannerSliderComponent
                responsive={responsive}
                swipeable={false}
                draggable={false}
                slidesToSlide={numberOfItems}
                renderButtonGroupOutside={true}
                arrows={true}
                autoPlay={autoPlay}
                className="w-carousel-d__list"
                itemClass={`w-carousel-d__list__item w-${numberOfItems}`}
            >
                {data.map((item, idx) => (
                    <a
                        key={`${idx}`}
                        href={item.url}
                        title={item.alt}
                        target={item.target}
                        rel={item.target === '_blank' ? 'nofollow noopener' : ''}
                    >
                        <img
                            src={item.img}
                            alt={item.alt}
                            title={item.alt}
                        />
                    </a>
                ))}
            </WidgetBannerSliderComponent>
        </div>
    );
};

export default WidgetBannerSliderDesktop;
